import { useTranslation } from 'react-i18next'

import Flexer from 'js/components/Flexer/Flexer'
import IconButton from 'js/components/IconButton/IconButton'
import { USER_ACTION } from 'js/lib/constants'
import UserChatButton from 'js/user/Profile/components/UserChatButton'

import VideoCallIcon from 'icons/camera-small.svg'
import ChatIcon from 'icons/chat-small.svg'

export const Actions = ({
    actions,
    user,
}: {
    actions: string[]
    user: { guid: string }
}) => {
    const { t } = useTranslation()

    return (
        <Flexer justifyContent="flex-end" gutter="none">
            {actions?.map((action) => {
                switch (action) {
                    case USER_ACTION.Chat:
                        return (
                            <UserChatButton key={action} entity={user}>
                                {({ label, onClick }) => (
                                    <IconButton
                                        variant="secondary"
                                        aria-label={label}
                                        onClick={onClick}
                                        radiusStyle="rounded"
                                        size="normal"
                                        tooltip={label}
                                        placement="right"
                                    >
                                        <ChatIcon />
                                    </IconButton>
                                )}
                            </UserChatButton>
                        )
                    case USER_ACTION.VideoCall:
                        return (
                            <IconButton
                                key={action}
                                variant="secondary"
                                aria-label="Video Call"
                                size="normal"
                                radiusStyle="rounded"
                                as="a"
                                href={`/videocall/chat/${user.guid}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                tooltip={t('global.video-call')}
                                placement="right"
                            >
                                <VideoCallIcon />
                            </IconButton>
                        )
                    default:
                        return null
                }
            })}
        </Flexer>
    )
}
